var exports = {
  "item": "x1cb7f6e3--54b67d--item",
  "mobile": "x1cb7f6e3--54b67d--mobile",
  "left-icon": "x1cb7f6e3--54b67d--left-icon",
  "name": "x1cb7f6e3--54b67d--name",
  "desktop": "x1cb7f6e3--54b67d--desktop",
};

module.exports = exports;
